import React from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";

export default ({ children, errors, ...props }) => (
  <Formik {...props}>
    {props => <Form errors={errors}>{children(props)}</Form>}
  </Formik>
);

class Form extends React.Component {
  getChildContext() {
    return {
      formik: {
        ...this.context.formik,
        errors: {
          ...this.context.formik.errors,
          ...this.props.errors
        }
      }
    };
  }

  render() {
    return this.props.children;
  }
}

Form.childContextTypes = {
  formik: PropTypes.object
};

Form.contextTypes = {
  formik: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/generic/form/formik/Formik/index.js